import { render, staticRenderFns } from "./CompanyInfoBaseForm.vue?vue&type=template&id=9212f6c0&scoped=true&"
import script from "./CompanyInfoBaseForm.vue?vue&type=script&lang=js&"
export * from "./CompanyInfoBaseForm.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInfoBaseForm.vue?vue&type=style&index=0&id=9212f6c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9212f6c0",
  null
  
)

export default component.exports